// camelize.ts
export function camelize(text: string): string {
  return text.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
}
